import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, DatePicker, Input, Modal, Select, Form, message, Upload } from "antd"
import { useForm } from "antd/lib/form/Form"
import { UploadOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 14 }
}

const upLoadProps = {
    name: 'files',
    data: { fileType: 1, bucketType: 4 },
    action: apiPrefix + '/global/upload_pic',
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
    current_room_number: string // 当前入住房号，可能为空
}

interface leftAmount {
    agreement_amount: number // 合同总金额，小数类型
    total_agreement_pay_amount: number // 合同已收金额，小数类型
    total_agreement_left_amount: number // 合同待收金额，小数类型
    total_agreement_refund_amount: number // 预计退款金额，小数类型
    left_deposit: number // 剩余押金
}

interface ep {
    "employee_id": string,
    "user_name": string
}

interface Prop {
    clientData?: Client
    storeID?: string
    onChange?: () => void
}

interface reciveRow {
    prov_pic_list: undefined | string[], // 凭证图片集合，上传图片接口返回的图片路径
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [data, setData] = useState<leftAmount>()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [isNeedCar, setIsNeedCar] = useState<number>(0)
    const [isDeposit, setIsDeposit] = useState<number>(0)

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        prov_pic_list: []
    }])

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/left_amount/info', {
            params: {
                check_in_id: param.id,
                type: 1
            }
        }).then((res: any) => {
            if (res) {
                setData(res)

                if (res.left_deposit > 0) {
                    setIsDeposit(1)
                } else {
                    setIsDeposit(0)
                }
            }
        })
    }, [])

    const onFinish = () => {
        if (!form.getFieldValue('check_out_time')) {
            message.warning('请选择出所时间!')
            return false
        }

        baseAxiosComplete.post('/keeper/check_in/detail/handle_check_out', {
            check_in_id: param.id,
            check_in_career: form.getFieldValue("check_in_career"),
            check_in_contacts: form.getFieldValue("check_in_contacts"),
            check_in_attend_activity: form.getFieldValue("check_in_attend_activity"),
            check_in_share_desire: form.getFieldValue("check_in_share_desire"),
            check_in_more_consume: form.getFieldValue("check_in_more_consume"),

            // check_out_deposit: form.getFieldValue("check_out_deposit"),
            // refund_deposit_amount: form.getFieldValue("refund_deposit_amount"),
            check_out_deposit: isDeposit,
            refund_deposit_amount: data?.left_deposit,
            refund_deposit_prov_list: reciveMoneyData[0].prov_pic_list,

            check_out_time: form.getFieldValue('check_out_time').format('YYYY-MM-DD HH:mm:ss'), // 出所时间
            check_out_way: form.getFieldValue("check_out_way"), // 出所方式
            check_out_remark: form.getFieldValue('check_out_remark'), // 出所备注
            check_out_need_drive: form.getFieldValue('check_out_need_drive'), // 出所是否需要车送，0不需要 1需要
            check_out_drive_address: form.getFieldValue('check_out_drive_address'), // 出所车送地址，当check_out_need_drive=1时必填
            check_out_drive_time: form.getFieldValue('check_out_drive_time') ? form.getFieldValue('check_out_drive_time').format('YYYY-MM-DD HH:mm:ss') : null, // 出所车送时间，当check_out_need_drive=1时必填
            need_wheel_chair: form.getFieldValue('need_wheel_chair'),
            need_baby_basket: form.getFieldValue('need_baby_basket')

        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    const uploadChange = (info: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)
            reciveD[0].prov_pic_list.push(info.file.response.data[0])

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            let i = reciveD[0].prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
            reciveD[0].prov_pic_list.splice(i, 1)

            setReciveMoneyData(reciveD)
        }
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 办理出所 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>办理出所</Button>

        <Modal title="办理出所" width={700} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <div>
                <div>
                    <p>客户姓名：{prop.clientData && prop.clientData.check_in_user_name}</p>
                    <p>手机号码：{prop.clientData && prop.clientData.check_in_phone}</p>
                    <p>入住房间：{prop.clientData && prop.clientData.current_room_number}</p>
                </div>

                <p style={{ fontWeight: 'bold', fontSize: 16 }}>带红色<span style={{ color: 'red' }}>*</span>号的表单项为必填项，请填写完整再提交表单！</p>

                <Form form={form} {...formItemLayout} style={{ marginTop: 20 }}>
                    <Form.Item label="职业" name="check_in_career" required>
                        <Select>
                            <Option key={1} value={1}>普通员工</Option>
                            <Option key={2} value={2}>保险业、金融业、老师</Option>
                            <Option key={3} value={3}>企业高管、网络达人、老板</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="周边人脉" name="check_in_contacts" required>
                        <Select>
                            <Option key={3} value={3}>高频探访（4次及以上）</Option>
                            <Option key={2} value={2}>中频探访（2-4次）</Option>
                            <Option key={1} value={1}>低频探访（2次及以下）</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="月子期间活动参与" name="check_in_attend_activity" required>
                        <Select>
                            <Option key={3} value={3}>报名2次及以上</Option>
                            <Option key={2} value={2}>报名1-2次</Option>
                            <Option key={1} value={1}>不报名</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="分享欲望" name="check_in_share_desire" required>
                        <Select>
                            <Option key={1} value={1}>经常发朋友圈/小红书/抖音</Option>
                            <Option key={0} value={0}>几乎不发朋友圈/小红书/抖音</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="再次消费能力" name="check_in_more_consume" required>
                        <Select>
                            <Option key={2} value={2}>明确表示二胎/三胎</Option>
                            <Option key={1} value={1}>明确表示需要产康/瑜伽</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="出所时间" name="check_out_time" required>
                        <DatePicker showTime />
                    </Form.Item>
                    <Form.Item label="出所方式" name="check_out_way" required>
                        <Select>
                            <Option key={1} value={1}>包含当天</Option>
                            <Option key={0} value={0}>不包含当天</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="备注" name="check_out_remark" required>
                        <Input />
                    </Form.Item>

                    {/* <Form.Item label="是否退押金" name="check_out_deposit" required>
                        <Select onChange={(v: number) => {
                            setIsDeposit(v)
                        }}>
                            <Option key={1} value={1}>是</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </Form.Item> */}

                    {isDeposit === 1 && <Fragment>
                        <Form.Item label="剩余押金">
                            {data?.left_deposit}元
                        </Form.Item>

                        {/* <Form.Item label="退押金金额" name="refund_deposit_amount" required>
                            <Input />
                        </Form.Item> */}

                        <Form.Item label="退押金凭证" name="refund_deposit_prov" required>
                            <Upload {...upLoadProps} onChange={(info: any) => {
                                uploadChange(info)
                            }}>
                                <Button icon={<UploadOutlined />} size="small" ></Button>
                            </Upload>
                        </Form.Item>
                    </Fragment>}

                    <Form.Item label="是否需要车送" name="check_out_need_drive" required>
                        <Select onChange={(v: number) => {
                            setIsNeedCar(v)
                        }}>
                            <Option key={1} value={1}>是</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </Form.Item>

                    {isNeedCar === 1 && <Fragment>
                        <Form.Item label="车送时间" name="check_out_drive_time" required>
                            <DatePicker showTime />
                        </Form.Item>
                        <Form.Item label="车送地址" name="check_out_drive_address" required>
                            <Input />
                        </Form.Item>

                        <Form.Item label="是否需要轮椅" name="need_wheel_chair" required>
                            <Select>
                                <Option key={1} value={1}>需要</Option>
                                <Option key={0} value={0}>不需要</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="是否需要婴儿提篮" name="need_baby_basket" required>
                            <Select>
                                <Option key={1} value={1}>需要</Option>
                                <Option key={0} value={0}>不需要</Option>
                            </Select>
                        </Form.Item>
                    </Fragment>}
                </Form>
            </div>
        </Modal>
    </Fragment>
}